import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { ShopinfoModel } from './model/shopinfo.model';
import { ShopinfoService } from './shopinfo.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-shopinfo',
  templateUrl: './shopinfo.component.html',
  styleUrls: ['./shopinfo.component.scss'],
  standalone: false
})
export class ShopinfoComponent implements DirtyCheck {
  shopList: ShopinfoModel[] = [];
  showSearch: boolean = false;
  isLoading = true;
  isFormDirty: boolean = false;
  filter: FilterListItemModel[] = [
    {
      title: "Code",
      column: "shop.code",
    },
    {
      title: "Name",
      column: "shop.name",
    },
    {
      title: "Area",
      column: "area_codes.name",
    },
    {
      title: "Shop Type",
      column: "shop_type",
    },

    {
      title: "Excl. Summary",
      column: "is_excluded_summary",
      type: "boolean",
      operators: [
        { title: "is", operator: "=" },
        { title: "is not", operator: "!=" }
      ],
      values: [
        { title: "Yes", value: "1" },
        { title: "No", value: "0" },
      ]
    },

    {
      title: "Published",
      column: "shop.publish_status",
      type: "boolean",
      operators: [
        { title: "is", operator: "=" },
        { title: "is not", operator: "!=" }
      ],
      values: [
        { title: "Active", value: "1" },
        { title: "Unpublished", value: "0" },
      ]
    },

  ];
  displayedColumns = ['code', 'name', 'area', 'shop_type', 'is_excluded_summary', 'publish_status', 'action'];

  //displayedColumns = ['code', 'name', 'area_id',,'shop_type','is_excluded_summary','publish_status','action'];
  pagingData = { length: 0, pageSize: 50, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: ShopinfoModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<ShopinfoModel>(true, []);
  dataSource = new MatTableDataSource(this.shopList);
  IsDownloading: boolean = false;
  permission: any;

  constructor(private breakpointObserver: BreakpointObserver,
    private ShopinfoService: ShopinfoService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService,
    private router: Router, private stateManagerService: StateManagerService) {

    this.shopList = [];
    this.permission = permissionService.getPagePermission("shop");
    console.log(this.permission);

  }
  isDirty(): boolean {
    throw new Error('Method not implemented.');
  }
  /**
     * initilaize the device model
     */
  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });
    //this.loadRating();
    // this.loadData();
  }
  /** 
   * Set the datasource
   */
  setDataSource(shopList: ShopinfoModel[]) {
    this.dataSource = new MatTableDataSource(shopList);
    this.dataSource.sort = this.sort;
  }
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {

    this.loadPreviousState();
    // this.loadData();
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {

    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);

    } else {
      this.setSortColumn('shop.name', 'asc');
      this.loadData();
    }

  }

  /**
   * Sets the sort column
   * @param column 
   * @param direction 
   */
  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction });
    this.sort.sort({
      id: column,
      start: direction,
      disableClear: false,
    });

    // this.sort.active=column;
    // this.sort.direction=direction;


  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.shopList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.shopList);
  }

  /**
   * Create sort order
   * @returns sort criteria
   */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }
  /**
   * Builds the request data to be send to API
   * @returns Request Data
   */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: [
            ...(searchParam.advSearch || []),
            ...this.getDefaultSearchParams(searchParam.advSearch),
          ],
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };

    return requestData;
  }

  /**
   * Check and apply default filter for is_system = 0.
   **/
  getDefaultSearchParams(searchFilter: any): ColumnFilter[] {
    var defFilter: any = [];
    if (
      searchFilter == undefined ||
      !searchFilter.some((sf: any) => sf.column == "shop.is_system")
    ) {
      defFilter.push({
        column: "shop.is_system",
        operator: "=",
        value: "0",
      });
    }
    return defFilter;
  }

  /**
    * Set the column filter and reaload the daaa
    * @param columFilter 
    */

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadData();

  }
  /**
     * On delete menu item selected
     * Confirm the action and call the api to update
     */
  onDelete(shopInfo: ShopinfoModel): void {
    const shopId = shopInfo.id;
    const message = `Are you sure, you want to delete ` + (shopInfo.name + "?");
    const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      console.log(dialogResult);
      if (dialogResult) {
        this.ShopinfoService.delete(shopInfo).subscribe({
          next: (response) => {
            if (response.status == 'SUCCESS') {
              // handle success
              let snckBarData: SnackBarData = {
                type: 'success',
                title: 'Saved',
                message: 'The record for ' + shopInfo.name + " has been deleted succesfully."
              }
              this.snackBarService.openSnackBar(snckBarData);
              this.loadData();
            } else {
              let snackBarData: SnackBarData = {
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          },
          error: (error) => {
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    });
  }
  /**
   * loads the data based on the conditions
   */
  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    let response = this.ShopinfoService.getShopList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        this.setDataSource(response.data.shops);
        this.pagingData.length = response.data.total_count;
        if (this.pagingData.length == 0) {
          let snackBarData: SnackBarData = {
            message: 'No data found. Please remove or change the filter if any.',
            title: 'No Data!!!',
            type: 'warn'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.selectedItem = undefined;
        } else {
          this.stateManagerService.setState(this.constructor.name, requestData);
          this.onRowSelected(this.shopList[0]);
        }
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.isLoading = false;
    });

  }

  /**
  * On shopinfo selected
  * @param shopInfo 
  */
  onRowSelected(shopInfo: ShopinfoModel): void {
    this.selectedItem = shopInfo;
    this.showSummaryPanel = true;
  }

  /**
    *  Set the sort param and relead the data
    * @param $event sort data
    * {"active": "email","direction": "asc"}
    *   
    */
  sortData($event: any): void {
    var sd = this.sort;
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: sd.active, order: sd.direction });
    this.loadData();
  }
  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
  getSearchParam(): SearchParam {

    return this.searchColumFilter;
  }

  /**
 * On edit the item
 * Show the edit dialog
 */
  onEdit(shopInfo: ShopinfoModel): void {

    this.router.navigate(['system/shop-edit', shopInfo.id]);
  }


  /**
   * 
   * @param event 
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {

    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    this.loadData();

  }
  /**
   * On Add clicked
   * Show the dialog to enter new shop
   */
  addClicked(): void {

    this.router.navigate(['system/shop-edit', 0]);

  }

  exportClicked() {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    this.IsDownloading = true;
    this.ShopinfoService.downloadExcel(requestData)
      .subscribe({
        next: blob => {
          // Download logic
          this.IsDownloading = false;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'shop_list.csv'; // Adjust filename if needed
          link.click();
          window.URL.revokeObjectURL(url);
          this.isLoading = false;


        },
        error: error => {
          // Handle errors
          this.IsDownloading = false;
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.isLoading = false;
          // Display user-friendly error message to the user
        }
      }
      );
  }

}
